import { Component, inject, OnInit } from "@angular/core";
import { PageContentWrapperComponent } from "../../features/page-content-wrapper/page-content-wrapper.component";
import { ENVIRONMENT } from "../../../../../libs/models/src/lib/injection.tokens";


@Component({
    selector: "app-empty",
    standalone: true,
    template: `
  <div class="page-container">
    <app-page-content-wrapper>
      <div class="page-title">
        <h1></h1>
      </div>
      <div class="page-content"></div>
    </app-page-content-wrapper>
  </div>`,
    styles: [],
    imports: [PageContentWrapperComponent]
})
export class EmptyComponent implements OnInit {
  environment = inject(ENVIRONMENT);


  ngOnInit() {
      window.location.href = this.environment.config.marketingSite;
  }
}
